// extracted by mini-css-extract-plugin
export default {"lds-ripple":"Loader_lds-ripple__BoErG"};